import { AI_WRITER_TOOL } from '@quicktools/shared-components/data/';

export const VERSION = process.env.NX_APP_VERSION;
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const BASE_URL = process.env.NX_BASE_URL;
export const COPY_WRITER_BASE_URL = `${BASE_URL}text/ai-writer/`;
export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;
export const RECAPTCHA_SITE_KEY = process.env.NX_RECAPTCHA_SITE_KEY;
export const QUICKTOOLS_API_BASE_URL = process.env.NX_QUICKTOOLS_API_BASE_URL;
export const TOOL_NAME = AI_WRITER_TOOL.id;
